// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Экран 4: чат на всю высоту окна, страница не прокручивается — только переписка. */
.tc-wrap {
  display: flex;
  height: 100vh;
  min-width: 0;
  overflow: hidden;
}
.tc-main {
  container-type: inline-size;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background: #fff;
}
.tc-top {
  flex: none;
  z-index: 5;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 12px;
  height: 56px;
  padding: 0 24px;
  border-bottom: 1px solid var(--v2-border-soft);
  white-space: nowrap;
  overflow: hidden;
}
.tc-title {
  font-weight: 700;
  flex: none;
}
.tc-new {
  margin-left: auto;
}
.tc-cur-name {
  font-weight: 600;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tc-cur > * {
  flex-shrink: 0;
}
.tc-cur .tc-cur-name {
  flex-shrink: 1;
}
/* Узкое окно (ширина самого чата): подписи кнопок сокращаются, строка не ломается. */
@container (max-width: 860px) {
  .tc-wide,
  .tc-own {
    display: none;
  }
}
@container (max-width: 640px) {
  .tc-mid {
    display: none;
  }
  .tc-top {
    gap: 8px;
    padding: 0 16px;
  }
  /* Название модели важнее подписей: прячем заголовок и плашку «только в тест-чате»
     (это же написано в открытой панели сравнения). */
  .tc-title,
  .tc-sep,
  .tc-top .tc-only {
    display: none;
  }
}
@container (max-width: 340px) {
  .tc-cur-name {
    display: none;
  }
}
.tc-sep {
  width: 1px;
  height: 20px;
  background: var(--v2-border);
  flex: none;
}
.tc-cur {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  min-width: 0;
  flex: 0 1 auto;
  overflow: hidden;
}
.tc-only {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--v2-orange-bg);
  color: var(--v2-orange);
  font-size: 12px;
  font-weight: 600;
}
.tc-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #fff;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  color: var(--v2-primary);
  white-space: nowrap;
  flex-shrink: 0;
}
.tc-btn:hover {
  border-color: var(--v2-primary);
}
.tc-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  padding: 24px 24px 12px;
}
.tc-feed {
  max-width: 820px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.tc-q {
  align-self: flex-end;
  max-width: 75%;
  background: var(--v2-hover);
  color: var(--v2-primary);
  padding: 10px 14px;
  border-radius: 16px 16px 4px 16px;
  white-space: pre-wrap;
  word-break: break-word;
}
.tc-answer {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.tc-answer-text {
  word-break: break-word;
}
.tc-model-caption {
  font-size: 12px;
  color: var(--v2-faint);
}
.tc-switch {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  color: var(--v2-orange);
}
.tc-switch b {
  font-weight: 400;
}
.tc-switch span {
  flex: 1;
  border-top: 1px dashed #f5d9a8;
}
.tc-empty {
  margin: 40px auto 0;
  max-width: 460px;
  text-align: center;
  color: var(--v2-muted);
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.tc-alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 10px;
  background: #fef2f2;
  color: #991b1b;
  font-size: 13px;
}
.tc-alert.is-money {
  background: var(--v2-orange-bg);
  color: var(--v2-orange);
}
.tc-input-zone {
  flex: none;
  background: #fff;
  padding: 8px 24px 16px;
  border-top: 1px solid var(--v2-bg);
}
.tc-input-wrap {
  max-width: 820px;
  margin: 0 auto;
}
.tc-input {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  border: 1px solid #d1d5db;
  border-radius: 14px;
  padding: 8px 10px 8px 16px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.tc-input:focus-within {
  border-color: var(--v2-primary);
}
.tc-input textarea {
  flex: 1;
  font: inherit;
  line-height: 22px;
  border: 0;
  outline: none;
  resize: none;
  padding: 3px 0;
  margin: 0;
  display: block;
  background: transparent;
  color: var(--v2-primary);
  /* Растёт вверх вместе с текстом (высоту ставит TestChatPage), дальше — прокрутка */
  max-height: min(320px, 40vh);
  overflow-y: auto;
  box-sizing: border-box;
}
.tc-send {
  flex: none;
  width: 36px;
  height: 36px;
  padding: 0;
  border-radius: 10px;
  border: 0;
  background: transparent;
  color: var(--v2-muted);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.tc-send:hover {
  color: var(--v2-primary);
}
.tc-send:disabled {
  color: #d1d5db;
  cursor: default;
}
.tc-hint {
  font-size: 12px;
  color: var(--v2-muted);
  margin-top: 6px;
  text-align: center;
}
/* Панель справа */
.tc-panel {
  flex: none;
  width: 360px;
  height: 100vh;
  overflow-y: auto;
  scrollbar-width: thin;
  background: #fff;
  border-left: 1px solid var(--v2-border);
  display: flex;
  flex-direction: column;
}
.tc-panel-head {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fff;
  padding: 12px 16px 10px;
  border-bottom: 1px solid var(--v2-border-soft);
}
.tc-psearch {
  position: relative;
  margin-top: 10px;
}
.tc-psearch svg {
  position: absolute;
  left: 10px;
  top: 11px;
}
.tc-psearch input {
  width: 100%;
  box-sizing: border-box;
  font: inherit;
  font-size: 13px;
  height: 36px;
  border: 1px solid #d1d5db;
  border-radius: 9px;
  padding: 0 10px 0 32px;
  color: var(--v2-primary);
  background: #fff;
  outline: none;
}
.tc-ptabs {
  display: flex;
  gap: 4px;
  margin-top: 10px;
  padding: 3px;
  background: var(--v2-hover);
  border-radius: 9px;
}
.tc-ptabs button {
  flex: 1;
  height: 28px;
  border-radius: 7px;
  border: 0;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  background: transparent;
  color: var(--v2-text-2);
  white-space: nowrap;
}
.tc-ptabs button.is-on {
  background: #fff;
  font-weight: 600;
  color: var(--v2-primary);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
.tc-plist {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.tc-pcard {
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid var(--v2-border);
}
.tc-pcard.is-cur {
  border: 2px solid var(--v2-primary);
  padding: 11px;
}
.tc-pmetrics {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  font-size: 12px;
  color: var(--v2-text-2);
}
.tc-papply {
  height: 32px;
  border-radius: 8px;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: 0;
  background: var(--v2-primary);
  color: #fff;
}
.tc-papply.is-cur {
  background: var(--v2-hover);
  color: var(--v2-faint);
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/pages/test-chat/test-chat.css"],"names":[],"mappings":"AAAA,oFAAoF;AACpF;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA,qFAAqF;AACrF;EACE;;IAEE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,QAAQ;IACR,eAAe;EACjB;EACA;qDACmD;EACnD;;;IAGE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,+BAA+B;EAC/B,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;EAClB,iCAAiC;EACjC,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,+BAA+B;AACjC;AACA;EACE,OAAO;EACP,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,cAAc;EACd,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,mFAAmF;EACnF,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA,kBAAkB;AAClB;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kCAAkC;AACpC;AACA;EACE,mCAAmC;EACnC,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;AACjB","sourcesContent":["/* Экран 4: чат на всю высоту окна, страница не прокручивается — только переписка. */\n.tc-wrap {\n  display: flex;\n  height: 100vh;\n  min-width: 0;\n  overflow: hidden;\n}\n.tc-main {\n  container-type: inline-size;\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n  background: #fff;\n}\n.tc-top {\n  flex: none;\n  z-index: 5;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  height: 56px;\n  padding: 0 24px;\n  border-bottom: 1px solid var(--v2-border-soft);\n  white-space: nowrap;\n  overflow: hidden;\n}\n.tc-title {\n  font-weight: 700;\n  flex: none;\n}\n.tc-new {\n  margin-left: auto;\n}\n.tc-cur-name {\n  font-weight: 600;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.tc-cur > * {\n  flex-shrink: 0;\n}\n.tc-cur .tc-cur-name {\n  flex-shrink: 1;\n}\n/* Узкое окно (ширина самого чата): подписи кнопок сокращаются, строка не ломается. */\n@container (max-width: 860px) {\n  .tc-wide,\n  .tc-own {\n    display: none;\n  }\n}\n@container (max-width: 640px) {\n  .tc-mid {\n    display: none;\n  }\n  .tc-top {\n    gap: 8px;\n    padding: 0 16px;\n  }\n  /* Название модели важнее подписей: прячем заголовок и плашку «только в тест-чате»\n     (это же написано в открытой панели сравнения). */\n  .tc-title,\n  .tc-sep,\n  .tc-top .tc-only {\n    display: none;\n  }\n}\n@container (max-width: 340px) {\n  .tc-cur-name {\n    display: none;\n  }\n}\n.tc-sep {\n  width: 1px;\n  height: 20px;\n  background: var(--v2-border);\n  flex: none;\n}\n.tc-cur {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 32px;\n  min-width: 0;\n  flex: 0 1 auto;\n  overflow: hidden;\n}\n.tc-only {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--v2-orange-bg);\n  color: var(--v2-orange);\n  font-size: 12px;\n  font-weight: 600;\n}\n.tc-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  color: var(--v2-primary);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.tc-btn:hover {\n  border-color: var(--v2-primary);\n}\n.tc-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  padding: 24px 24px 12px;\n}\n.tc-feed {\n  max-width: 820px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n.tc-q {\n  align-self: flex-end;\n  max-width: 75%;\n  background: var(--v2-hover);\n  color: var(--v2-primary);\n  padding: 10px 14px;\n  border-radius: 16px 16px 4px 16px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n.tc-answer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.tc-answer-text {\n  word-break: break-word;\n}\n.tc-model-caption {\n  font-size: 12px;\n  color: var(--v2-faint);\n}\n.tc-switch {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 12px;\n  color: var(--v2-orange);\n}\n.tc-switch b {\n  font-weight: 400;\n}\n.tc-switch span {\n  flex: 1;\n  border-top: 1px dashed #f5d9a8;\n}\n.tc-empty {\n  margin: 40px auto 0;\n  max-width: 460px;\n  text-align: center;\n  color: var(--v2-muted);\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.tc-alert {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 14px;\n  border-radius: 10px;\n  background: #fef2f2;\n  color: #991b1b;\n  font-size: 13px;\n}\n.tc-alert.is-money {\n  background: var(--v2-orange-bg);\n  color: var(--v2-orange);\n}\n.tc-input-zone {\n  flex: none;\n  background: #fff;\n  padding: 8px 24px 16px;\n  border-top: 1px solid var(--v2-bg);\n}\n.tc-input-wrap {\n  max-width: 820px;\n  margin: 0 auto;\n}\n.tc-input {\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 14px;\n  padding: 8px 10px 8px 16px;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n.tc-input:focus-within {\n  border-color: var(--v2-primary);\n}\n.tc-input textarea {\n  flex: 1;\n  font: inherit;\n  line-height: 22px;\n  border: 0;\n  outline: none;\n  resize: none;\n  padding: 3px 0;\n  margin: 0;\n  display: block;\n  background: transparent;\n  color: var(--v2-primary);\n  /* Растёт вверх вместе с текстом (высоту ставит TestChatPage), дальше — прокрутка */\n  max-height: min(320px, 40vh);\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n.tc-send {\n  flex: none;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border-radius: 10px;\n  border: 0;\n  background: transparent;\n  color: var(--v2-muted);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.tc-send:hover {\n  color: var(--v2-primary);\n}\n.tc-send:disabled {\n  color: #d1d5db;\n  cursor: default;\n}\n.tc-hint {\n  font-size: 12px;\n  color: var(--v2-muted);\n  margin-top: 6px;\n  text-align: center;\n}\n/* Панель справа */\n.tc-panel {\n  flex: none;\n  width: 360px;\n  height: 100vh;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  background: #fff;\n  border-left: 1px solid var(--v2-border);\n  display: flex;\n  flex-direction: column;\n}\n.tc-panel-head {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #fff;\n  padding: 12px 16px 10px;\n  border-bottom: 1px solid var(--v2-border-soft);\n}\n.tc-psearch {\n  position: relative;\n  margin-top: 10px;\n}\n.tc-psearch svg {\n  position: absolute;\n  left: 10px;\n  top: 11px;\n}\n.tc-psearch input {\n  width: 100%;\n  box-sizing: border-box;\n  font: inherit;\n  font-size: 13px;\n  height: 36px;\n  border: 1px solid #d1d5db;\n  border-radius: 9px;\n  padding: 0 10px 0 32px;\n  color: var(--v2-primary);\n  background: #fff;\n  outline: none;\n}\n.tc-ptabs {\n  display: flex;\n  gap: 4px;\n  margin-top: 10px;\n  padding: 3px;\n  background: var(--v2-hover);\n  border-radius: 9px;\n}\n.tc-ptabs button {\n  flex: 1;\n  height: 28px;\n  border-radius: 7px;\n  border: 0;\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  background: transparent;\n  color: var(--v2-text-2);\n  white-space: nowrap;\n}\n.tc-ptabs button.is-on {\n  background: #fff;\n  font-weight: 600;\n  color: var(--v2-primary);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n}\n.tc-plist {\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.tc-pcard {\n  border-radius: 12px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border: 1px solid var(--v2-border);\n}\n.tc-pcard.is-cur {\n  border: 2px solid var(--v2-primary);\n  padding: 11px;\n}\n.tc-pmetrics {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 12px;\n  font-size: 12px;\n  color: var(--v2-text-2);\n}\n.tc-papply {\n  height: 32px;\n  border-radius: 8px;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  border: 0;\n  background: var(--v2-primary);\n  color: #fff;\n}\n.tc-papply.is-cur {\n  background: var(--v2-hover);\n  color: var(--v2-faint);\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
